import { VoiceWindow } from './VoiceWindow';

/**
 * Near-full-screen Voice overlay (scrim + window). Body lives in
 * {@link VoiceWindow}; this name stays as the GlobalVoiceAssistant mount
 * point and for existing tests/stories.
 */
export function VoiceWorkspaceOverlay() {
  return <VoiceWindow presentation="overlay" />;
}
